import { isProductType } from '@/views/comunicaciones-plantillas/editor/hooks/use-create-template';

type TTemplateProductLoaderArgs = {
  params: {
    product?: string;
  };
};

export const loader = ({ params }: TTemplateProductLoaderArgs) => {
  if (!isProductType(params.product ?? '')) {
    throw new Response(null, { status: 404 });
  }

  return null;
};
